export enum LegalForm {
  AG = "AG",
  GmbH = "GmbH",
  GBR = "GBR",
  UG = "UG",
  KG = "KG",
  OHG = "OHG",
  EK = "EK",
  EV = "EV",
  LLP = "LLP",
  SE = "SE",
  EG = "EG",
  Foreign = "foreign",
  KGaa = "KGaa",
}
